module.exports = __webpack_public_path__ + "static/media/a41.a6ddc69c.jpg";